export function getEmptyCellContent() {
  return '--';
}